let Import = {
  connections: async function ({ limit = 100, offset = 0 } = {}) {
    try {
      const authToken = await localStorage.getItem("token");
      const url = `${process.env.REACT_APP_API_BASE_URL}/import/connections?limit=${limit}&offset=${offset}`;
      const request = new Request(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        })
      });
      const response = await fetch(request);

      if (response.status === 401) {
        await localStorage.removeItem("token");
        throw new Error("Unauthorized");
      }

      const json = await response.json();
      return json;
    } catch (exception) {
      console.log(exception);
      throw exception;
    }
  }
};

export default Import;
